import { connect } from 'react-redux';

import {
  actionCleanupProvincesName,
  actionGetDiscoveryProvinces,
  actionGetProvincesName,
} from 'store/discover-province/actions';
import { actionGetDiscoveryCategories } from 'store/actions';
import ManagerDiscoveryPlaceCreate from './ManagerDiscoveryPlaceCreate';

const mapStateToProps = (state) => ({
  provincesLoading: state.DiscoverProvince.provincesLoading,
  provinces: state.DiscoverProvince.provinces,

  provincesNameLoading: state.DiscoverProvince.provincesNameLoading,
  provincesName: state.DiscoverProvince.provincesName,

  categoriesLoading: state.DiscoverCategory.categoriesLoading,
  categories: state.DiscoverCategory.categories,
});

const mapDispatchToProps = {
  actionGetDiscoveryProvinces,
  actionGetProvincesName,
  actionCleanupProvincesName,
  actionGetDiscoveryCategories,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ManagerDiscoveryPlaceCreate);
